import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { removeObject } from "find-and";
import { ActionsGroup, Dialog, DialogContent, DialogTitle, IconButton } from "@evergis/ui";

import { Content } from "../DeleteResources/styled";
import { Actions } from "../DeleteResources/components/Actions";
import { useDialogInfo, useDialogReset } from "../../../hooks/useDialogs";
import { deleteLayerMeta } from "../../../ducks/project/project";
import { useProjectInfo, useProjectUpdate } from "../../../ducks/project/hooks";

export const DIALOG_STYLE = {
  maxWidth: "36rem",
};

export const DeleteGroup: FC = () => {
  const { t } = useTranslation("dialogs");
  const {
    resources: [layerName],
  } = useDialogInfo(true);
  const dispatch = useDispatch();
  const mutation = useProjectUpdate();
  const closeDialog = useDialogReset();
  const [{ name: projectName, content }] = useProjectInfo();
  const cancelDelete = useDialogReset();

  const deleteResources = useCallback(() => {
    mutation({
      name: projectName,
      content: {
        ...content,
        items: removeObject(content.items, { name: layerName }),
      },
    });

    dispatch(deleteLayerMeta(layerName));
    closeDialog();
  }, [closeDialog, content, dispatch, layerName, mutation, projectName]);

  return (
    <Dialog isOpen modal onCloseRequest={cancelDelete} maxWidth={DIALOG_STYLE.maxWidth}>
      <DialogTitle>
        <ActionsGroup>{t("deleteResources.groupDeletion")}</ActionsGroup>
        <ActionsGroup>
          <IconButton kind={"close"} onClick={closeDialog} />
        </ActionsGroup>
      </DialogTitle>
      <DialogContent>
        <Content>{t("deleteResources.confirmDeletionOfGroup")}</Content>
      </DialogContent>
      <Actions deleteResources={deleteResources} cancel={cancelDelete} />
    </Dialog>
  );
};
